import { Col, Input, Row, Form, Radio, Typography } from 'antd'
import React from 'react'
import { useSelector } from 'react-redux'
import { blockInvalidChar } from '../../../Utilities/numberValidation'
const { Title, Text } = Typography;

const amountPattern = {
  pattern: /^(\d{0,15}(\.\d{0,2})?)?$/,
  message: 'Please enter up to 15 numbers with 2 decimal places.',
};

const BackupRateRule = () => {
  // The DBSC method needs an active DBSC integration on this channel
  const installedCarriers = useSelector(state => state.installedCarriers)
  const isDbscActive = installedCarriers?.some(c => c.slug === 'dbsc' && +c.is_enabled === 1)

  return (
    <>
      <Row gutter={30}>
        <Col className='gutter-row' xs={24} sm={24} md={24} lg={24} xl={24}>
          <Title level={5}>Rating Method</Title>
        </Col>
      </Row>
      <Form.Item
        className='mb-2'
        name='backup_rate_method'
        rules={[{ required: true, message: 'Please select a rating method.' }]}
      >
        <Radio.Group className='w-100'>
          <Form.Item noStyle shouldUpdate={(prev, cur) => prev.backup_rate_method !== cur.backup_rate_method}>
            {({ getFieldValue }) => {
              const method = getFieldValue('backup_rate_method');
              return (
                <Row gutter={30}>
                  <Col span={24}>
                    <Radio value='flat_rate'>Flat Rate</Radio>
                    <Form.Item
                      className='mb-3 mt-1'
                      name='flat_rate'
                      rules={[{ required: method === 'flat_rate', message: 'Flat Rate is required.' }, amountPattern]}
                    >
                      <Input type='number' step='0.01' min={0} onKeyDown={blockInvalidChar}
                        disabled={method !== 'flat_rate'} placeholder='Enter flat rate' />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Radio value='quantity'>Rate × Product Quantity</Radio>
                    <Form.Item
                      className='mb-3 mt-1'
                      name='x_quantity'
                      rules={[{ required: method === 'quantity', message: 'Rate per item is required.' }, amountPattern]}
                    >
                      <Input type='number' step='0.01' min={0} onKeyDown={blockInvalidChar}
                        disabled={method !== 'quantity'} placeholder='Enter rate per item' />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Radio value='percentage'>Percentage of Cart Subtotal</Radio>
                    <Form.Item
                      className='mb-3 mt-1'
                      name='percentage_of_cart_price'
                      rules={[
                        { required: method === 'percentage', message: 'Percentage is required.' },
                        amountPattern,
                        {
                          validator: (_, value) =>
                            !value || parseFloat(value) <= 100
                              ? Promise.resolve()
                              : Promise.reject(new Error('Percentage cannot be more than 100.')),
                        },
                      ]}
                    >
                      <Input type='number' step='0.01' min={0} max={100} onKeyDown={blockInvalidChar}
                        disabled={method !== 'percentage'} placeholder='Enter percentage' />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Radio value='dbsc' disabled={!isDbscActive}>Use the Distance Based Shipping Rates' Backup Rate Profile.</Radio>
                    <div className='mt-1' style={{ fontSize: 14 }}>
                      <Text type='secondary'>
                        Requires an active Distance Based Shipping Calculator integration. The rate comes from its
                        Backup Rate Profile.
                      </Text>
                    </div>
                  </Col>
                </Row>
              );
            }}
          </Form.Item>
        </Radio.Group>
      </Form.Item>
    </>
  )
}

export default BackupRateRule
